import { Room } from '../../../Constants';
import { TEXTURES_URL } from '../../../Settings';

export function getTextureUrl(textureId) {
    if (textureId === null) {textureId = 155}
    let textureIdZeroFilled = ('00000' + textureId).slice(-5);
    return `${TEXTURES_URL}Texture${textureIdZeroFilled}.png`;
}

export function getCardTextureId(cardId) {
    const CARDS = [null,
        84, 85, 86, 87, 88, 89,
        90, 91, 92, 93, 94, 95,
        96, 97, 98, 99, 100, 101,
        102, 103, 104, 105, 106, 107,
        108, 109, 110, 111, 112, 113,
        114, 115, 116, 117, 118, 119,
        120, 121,
        169, 170, 171, 172, 173, 174,
        175, 176, 177, 178, 179, 180,
        181, 182, 183, 184, 185, 186,
        187, 188, 189, 190, 191, 192,
        193, 194, 195, 196, 197, 198
    ]
    return CARDS[cardId];
}

export function captainCardTextureByFactionId(factionId) {
    const CARDS = [null, 137, 138, 139, 140, 141, 142]
    return CARDS[factionId];
}

export function hotelCardTextureByFactionId(factionId) {
    const CARDS = [null, 158, 159, 160, 161, 162, 163]
    return CARDS[factionId];
}

export function getCardTextureUrl(cardId) {
    return getTextureUrl(getCardTextureId(cardId));
}

export function getCaptainCardUrl(factionId) {
    return getTextureUrl(captainCardTextureByFactionId(factionId));
}

export function getHotelCardUrl(factionId) {
    return getTextureUrl(hotelCardTextureByFactionId(factionId));
}

export function getFactionTextureId(factionId) {
    const FACTION_TEXTURES = [ null, 77, 78, 79, 80, 81, 82 ];
    return FACTION_TEXTURES[factionId];
}


export function getFactionTextureUrl(factionId) {
    return getTextureUrl(getFactionTextureId(factionId));
}


export function getAmenityTextureUrl(amenityId) {
    const UNUPGRADED_AMENITY_IDS = [null, 14, 16, 18, 20, 22, 24]
    return getTextureUrl(UNUPGRADED_AMENITY_IDS[amenityId]);
}

export function getBedTextureUrl(bedId) {
    const UNUPGRADED_BED_IDS = [null, 26, 28, 30, 32, 34, 36, 58];
    return getTextureUrl(UNUPGRADED_BED_IDS[bedId]);
}

export function getFactionActionTextureUrl(factionId) {
    const FACTION_ACTIONS_BY_FACTION = [null, 59, 60, 61, 62, 63, 64];
    return getTextureUrl(FACTION_ACTIONS_BY_FACTION[factionId]);
}

export function getLodgingTextureUrl(factionId) {
    const UNUPGRADED_LODGING_IDS = [null, 38, 40, 42, 44, 46, 48]
    return getTextureUrl(UNUPGRADED_LODGING_IDS[factionId]);
}

export function getRoomName(roomId) {
    return Room.NAMES[roomId];
}
